import { httpClient } from "../../lib/http-client";

// Bearer-authed spec from pf-developer-network — the distilled, cURL-enriched
// bundle enterprise-api publishes to S3 — served under the /pfdn gateway prefix.
const SPEC_PATH = "/pfdn/v1/openapi.json";

export async function fetchApiSpec(): Promise<object> {
  const { data } = await httpClient.get<object>(SPEC_PATH);
  return data;
}
